import { Action } from 'redux';
import { ILogt } from '../models/logT';
import LogTSearchResponse from './logTSearchResponse';

export enum LogtActionTypes {
    SEARCH_LOGT = 'SEARCH_LOGT',
    SEARCH_LOGT_ALL = 'SEARCH_LOGT_ALL',
    SEARCH_LOGT_SUCCESS = 'SEARCH_LOGT_SUCCESS',
    SEARCH_LOGT_ALL_SUCCESS = 'SEARCH_LOGT_ALL_SUCCESS',
    SEARCH_LOGT_ERROR = 'SEARCH_LOGT_ERROR',
    SEARCH_LOGT_ALL_ERROR = 'SEARCH_LOGT_ALL_ERROR',
    CLEAR_LOGT = 'CLEAR_LOGT'
}

export interface SearchLogtAction extends Action<typeof LogtActionTypes.SEARCH_LOGT> {
    type: typeof LogtActionTypes.SEARCH_LOGT;
}

export interface SearchLogtAllAction extends Action<typeof LogtActionTypes.SEARCH_LOGT_ALL> {
    type: typeof LogtActionTypes.SEARCH_LOGT_ALL;
}

export interface SearchLogtSuccessAction extends Action<typeof LogtActionTypes.SEARCH_LOGT_SUCCESS> {
    type: typeof LogtActionTypes.SEARCH_LOGT_SUCCESS;
    payload: LogTSearchResponse;
}

export interface SearchLogtAllSuccessAction extends Action<typeof LogtActionTypes.SEARCH_LOGT_ALL_SUCCESS> { 
    type: typeof LogtActionTypes.SEARCH_LOGT_ALL_SUCCESS;
    payload: ILogt[];
}

export interface SearchLogtErrorAction extends Action<typeof LogtActionTypes.SEARCH_LOGT_ERROR> {
    type: typeof LogtActionTypes.SEARCH_LOGT_ERROR;
    error: string;
}

export interface SearchLogtAllErrorAction extends Action<typeof LogtActionTypes.SEARCH_LOGT_ALL_ERROR> { 
    type: typeof LogtActionTypes.SEARCH_LOGT_ALL_ERROR;
    error: string;
}

export interface ClearLogtAction extends Action<typeof LogtActionTypes.CLEAR_LOGT> {
    type: typeof LogtActionTypes.CLEAR_LOGT;
}

// Union type for all Logt actions
export type LogtActions =
    SearchLogtAction |
    SearchLogtAllAction |         
    SearchLogtSuccessAction |
    SearchLogtAllSuccessAction | 
    SearchLogtErrorAction |
    SearchLogtAllErrorAction |  
    ClearLogtAction;
